"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFulfilled = exports.isRejected = exports.daoObjSchemaDef = void 0;
const joi_1 = __importDefault(require("joi"));
const time_1 = require("../util/time");
exports.daoObjSchemaDef = {
    _id: joi_1.default.alternatives(joi_1.default.string(), joi_1.default.object().keys({
        id: joi_1.default.alternatives(joi_1.default.string(), joi_1.default.object()),
        _bsontype: joi_1.default.allow('ObjectId'),
    })),
    lastUpdated: joi_1.default.string().default(() => (0, time_1.buildNow)()().toISOString()),
};
const isRejected = (input) => input.status === 'rejected';
exports.isRejected = isRejected;
const isFulfilled = (input) => input.status === 'fulfilled';
exports.isFulfilled = isFulfilled;
